import React, { useState, useCallback } from "react";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";
import axios from "axios";

const SettingContext = React.createContext({
  state: { settingList: {}, setting: {} },
  actions: {
    getSetting: () => {},
    getSettingList: () => {},
  },
});

const SettingProvider = ({ children }) => {
  const [settingList, setSettingList] = useState([]);
  const [connectHistoryList, setConnetHistoryList] = useState([]);
  
  const getSettingList = useCallback(() => {
    HttpAction({
      url:"api/admin/attach/list", 
      method: "get",
     
    }).then((res) => {
      if (res.code === 200) {
        setSettingList(res.data);
      } else {
      }
    });
  }, []);

  const updateSetting = useCallback((settingData) => {
    HttpAction({
      url: "api/admin/attach",
      method: "post",
      data: {
        limitSize: Number(settingData.limitSize),
        menuCode: settingData.menuCode,
      }
    }).then((res) => {
      if (res.code === 200) {
        getSettingList()
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getConnectHistoryList = useCallback(async(pageInfo) => {
    let baseURL =process.env.REACT_APP_API_URL
    axios({
      url:`${baseURL}/api/admin/menu-connect/connect-history`,
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        connectDateEnd: pageInfo && pageInfo.connectDateEnd,
        connectDateStart: pageInfo && pageInfo.connectDateStart,
        connectRoleName: pageInfo && pageInfo.connectRoleName,
        deptName: pageInfo && pageInfo.deptName,
      },
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        Language: process.env.REACT_APP_LANGUAGE,
      },
    }).then((res) => {
      if (res.data.code === 200) {
        setConnetHistoryList(res.data.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  
  const value = {
    state: {  settingList, connectHistoryList },
    actions: { getSettingList, updateSetting, getConnectHistoryList },
  };

  return (
    <SettingContext.Provider value={value}>
      {children}
    </SettingContext.Provider>
  );
};

const { Consumer: SettingConsumer } = SettingContext;

export { SettingProvider, SettingConsumer, SettingContext };

export default SettingContext;
